import { PersonInfo, Pronoun, ROLE } from '../../consts';
import image from './phil-chmalts.jpg';

export const PhilipChmalts: PersonInfo = {
  firstName: 'Phil',
  lastName: 'Chmalts',
  image,
  pronoun: Pronoun.HE,
  role: ROLE.ENGINEERING_MANAGER,
};
